// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuditTrail, Deal } from '@interfaces/deal.interfaces';
import { Dealer } from '@interfaces/dealer.interfaces';
import { DdjDocument } from '@interfaces/document.interfaces';
import { DealershipService } from '@services/dealership.service';
import { formatDateTime } from '../../utils/format-util';

@Component({
    selector: 'audit-trail-modal',
    templateUrl: './audit-trail-modal.component.html',
    styleUrls: ['./audit-trail-modal.component.scss'],
})
export class AuditTrailModalComponent {
    public showDiff: boolean = false;
    public auditTrail: AuditTrail[] = [];
    public deal: Deal = null;
    public dealership: Dealer = null;
    public doc: DdjDocument = null;
    public uniqueTitle: string;

    constructor(
        private dealershipService: DealershipService,
        private dialogRef: MatDialogRef<AuditTrailModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.auditTrail = data.trail;
        this.dealership = this.dealershipService.dealershipInfo;
        this.doc = data.doc;
        this.deal = data.deal;
        this.uniqueTitle = data.uniqueTitle;
        if ('showDiff' in data) {
            this.showDiff = data.showDiff;
        }
    }

    close() {
        this.dialogRef.close();
    }

    formattedDate(dateString: string) {
        return formatDateTime(dateString, { includeSeconds: true, includeComma: false });
    }

    printTest() {
        const divContents = document.getElementById('print-content');
        const a = window.open('audit', 'print', 'height=700, width=700');

        a.document.write('<html>');

        divContents.style.fontFamily = 'Consolas, Courier, monospace';

        const header = document.getElementById('header');
        const subHeader = document.getElementById('sub-header');
        const dealNumber = document.getElementById('deal-number');

        if (header && subHeader) {
            header.style.marginBottom = '5px';
            subHeader.style.color = '#666';
            subHeader.style.marginTop = '0';
        } else {
            dealNumber.style.marginBottom = '5px';
        }

        const infoWrap = document.getElementById('info-wrap');
        infoWrap.style.display = 'flex';
        infoWrap.style.marginBottom = '1.5rem';

        const customer = document.getElementById('customer');
        customer.style.marginRight = '2rem';

        const generatingReport = document.getElementById('generating-report');
        generatingReport.style.marginRight = '2rem';

        const reportRunDate = document.getElementById('report-run-date');
        reportRunDate.style.marginRight = '2rem';

        const auditWrap = document.getElementById('audit-wrap');
        auditWrap.style.border = '3px solid #1a428a';

        a.document.write(divContents.innerHTML);
        a.document.write('</body></html>');
        a.document.close();
        a.print();
    }
}
